module.exports = __webpack_public_path__ + "img/dashboards.a80edca1.png";